import {Typography, Box} from '@mui/material';

/**
 * Error text with the character count.
 */
export const ErrorWithCharacterCount = (props: {
  error: string;
  characterCount: number;
  maxCharacters: number;
}) => {
  return (
    <Box
      sx={{
        marginTop: '3px',
        marginRight: '14px',
        marginLeft: '14px',
        marginBottom: '0px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <Typography
          variant="caption"
          align="left"
          sx={{
            color: 'error.main',
          }}
          component="p"
        >
          {props.error}
        </Typography>
      </Box>
      <Box>
        <Typography
          variant="caption"
          align="right"
          sx={{
            color: 'error.main',
          }}
          component="p"
        >
          ({props.characterCount}/{props.maxCharacters})
        </Typography>
      </Box>
    </Box>
  );
};
